import Vue from "vue";

export const DEFAULT_LOCALE = "zh-CN";
export const LOCALE_STORAGE_KEY = "townsquare.locale";

export const locales = [
  { code: "zh-CN", label: "中文" },
  { code: "en-US", label: "English" },
];

const messages = {
  "zh-CN": {
    app: {
      titlePublic: "染然钟楼 城镇广场",
      titleGrimoire: "染然钟楼 魔典",
    },
    common: {
      language: "语言",
      chinese: "中文",
      english: "English",
      customScript: "自定义剧本",
      customScriptCharacters: "自定义剧本 / 角色",
      customNote: "自定义标记",
      good: "好人",
      evil: "邪恶",
      close: "关闭",
      back: "返回",
      copyJson: "复制 JSON",
      loadState: "加载状态",
      uploadJson: "上传 JSON",
      enterUrl: "输入 URL",
      add: "添加",
      edit: "编辑",
      remove: "移除",
      ok: "确定",
      cancel: "取消",
    },
    announcements: {
      title: "公告",
      version: "当前版本：{version}",
      loading: "正在加载公告...",
      empty: "暂无公告",
      failed: "公告加载失败",
      backToList: "返回列表",
      publishedAt: "发布时间：{time}",
      applicableVersion: "适用版本：{version}",
      types: {
        notice: "公告",
        update: "更新",
        maintenance: "维护",
        important: "重要",
      },
    },
    menu: {
      recentNominations: "最近提名：{count}",
      sessionTitle: "本局还有 {count} 名其他玩家{latency}",
      latency: "（延迟 {ping}ms）",
      grimoire: "魔典",
      settings: "设置",
      hide: "隐藏",
      show: "显示",
      charactersVisible: "角色：显示中",
      charactersHidden: "角色：隐藏中",
      switchToNight: "切换到夜晚",
      switchToDay: "切换到白天",
      nightOrder: "夜晚顺序",
      zoom: "缩放",
      backgroundImage: "背景图片",
      showCustomImages: "显示自定义图片",
      statusEffects: "醉酒/中毒特效",
      statusEffectsOn: "开启",
      statusEffectsOff: "关闭",
      disableAnimations: "禁用动画",
      changePlayerName: "修改名字",
      muteSounds: "静音",
      storyLog: "主持日志",
      privateChat: "私聊",
      webLogin: "网页登录",
      playing: "游玩中",
      hosting: "主持中",
      liveSession: "在线房间",
      host: "主持（说书人）",
      join: "加入（玩家）",
      delayTo: "到{target}的延迟",
      hostTarget: "主持",
      playersTarget: "玩家",
      copyPlayerLink: "复制玩家链接",
      copyShareLink: "复制分享链接",
      sendCharacters: "发送角色",
      voteHistory: "投票记录",
      leaveSession: "离开房间",
      players: "玩家",
      add: "添加",
      randomize: "随机排序",
      removeAll: "全部移除",
      characters: "角色",
      selectEdition: "选择版本",
      selectScript: "选择剧本",
      chooseAssign: "选择并分配",
      addFabled: "添加传奇角色",
      help: "帮助",
      referenceSheet: "角色参考表",
      nightOrderSheet: "夜晚顺序表",
      clearSeats: "清空座位",
      my: "我的",
      scriptLibrary: "剧本列表",
      roleLibrary: "角色列表",
      tokenGenerator: "角色 token 生成",
      myUploads: "我的上传",
      downloadRuntimeLog: "下载日志",
      tools: "工具",
      imageGenerator: "图片生成",
      gameStateJson: "游戏状态 JSON",
      scriptCreator: "剧本创作",
      joinDiscord: "加入 Discord",
      sourceCode: "源代码",
      promptBackground: "输入自定义背景 URL",
      promptHost: "输入本局频道编号 / 名称",
      promptJoin: "输入要加入的频道编号 / 名称",
      promptPlayerName: "玩家名称",
      promptJoinPlayerName: "请输入你的玩家名称",
      promptPlayerCount: "请输入要添加的玩家人数，或直接输入一个玩家名称",
      confirmDistribute: "确定要把已分配的角色发送给所有已入座玩家吗？",
      confirmCustomImages:
        "确定允许自定义图片吗？恶意剧本作者可能通过这种方式追踪你的 IP 地址。",
      confirmLeave: "确定要离开当前在线游戏吗？",
      confirmRandomize: "确定要随机排列座位吗？",
      confirmClearPlayers: "确定要移除所有玩家吗？",
      confirmClearRoles: "确定要移除所有玩家角色吗？",
    },
    roleDraw: {
      title: "玩家抽取角色",
      simulateRoleDraw: "模拟玩家抽取角色",
      yourTurn: "轮到你抽取角色",
      drawButton: "抽取角色",
      remaining: "剩余 {count} 个未抽",
      poolCount: "角色池 {count} 个",
      startSeat: "起始座位",
      forward: "顺序",
      reverse: "逆序",
      start: "开始抽取",
      manualDefaultRandom: "允许说书人帮当前玩家随机抽",
      autoDefaultRandom: "超时后默认随机抽取",
      autoDrawSeconds: "等待秒数",
      helpCurrentPlayerDraw: "帮当前玩家随机抽取",
      currentSeat: "当前抽取 {seat} 号玩家",
      countdown: "倒计时 {seconds} 秒",
    },
    login: {
      title: "网页登录",
      qrAlt: "网页登录二维码",
      pending: "请用小程序【染助手】首页右上角扫码确认登录",
      approved: "登录成功",
      expired: "二维码已过期，请刷新",
      failed: "登录失败",
      retrying: "网络波动，正在重试...",
      refresh: "刷新二维码",
      expiresIn: "{seconds} 秒后过期",
      loggedIn: "已登录",
      expiredSession: "登录已过期，请重新扫码登录",
      confirmLogout: "确定要退出当前网页登录吗？",
      createFailed: "创建登录二维码失败",
      pollFailed: "检查登录状态失败",
      missingUniCloudConfig: "未配置 uniCloud 网页端服务空间参数",
      missingUniCloudSdk: "uniCloud Web SDK 未加载",
      networkError: "登录请求失败，请刷新二维码后重试",
    },
    settings: {
      entry: "设置",
      title: "设置",
      profile: {
        title: "个人资料",
        avatarUrl: "头像地址",
        avatarPlaceholder: "https://example.com/avatar.png",
        nickname: "名字",
        nicknamePlaceholder: "输入显示名字",
        saved: "个人资料已保存",
        saveFailed: "保存个人资料失败",
      },
      ai: {
        title: "AI 配置",
        enabled: "启用 AI",
        provider: "服务商",
        baseUrl: "网站地址",
        apiKey: "API Key",
        apiKeyPlaceholder: "留空则沿用服务器已保存的 key",
        chatModel: "问答模型",
        imageModel: "生图模型",
        loadFailed: "读取 AI 配置失败",
        saveFailed: "保存 AI 配置失败",
        saved: "AI 配置已保存",
      },
      actions: {
        saveProfile: "保存个人资料",
        saveAi: "保存 AI 配置",
      },
    },
    myScripts: {
      libraryTitle: "剧本列表",
      libraryHint: "公开剧本库",
      myUploadsTitle: "我的上传",
      myUploadsHint: "管理我提交的剧本",
      upload: "上传",
      uploadTitle: "上传剧本",
      addCover: "添加封面",
      addImage: "添加图片",
      scriptType: "剧本类型",
      reasoning: "推理",
      fun: "娱乐",
      jsonFile: "JSON 文件",
      chooseJson: "选择 JSON",
      pasteJson: "粘贴 JSON",
      pasteJsonPlaceholder: "可直接粘贴剧本 JSON 内容",
      submit: "提交审核",
      submitting: "提交中",
      uploaded: "已提交审核",
      tabs: {
        scripts: "剧本",
        roles: "角色",
      },
      searchPlaceholder: "搜索剧本 / 作者",
      searchMinePlaceholder: "搜索我的上传",
      searchRolesPlaceholder: "搜索我的自制角色",
      loading: "加载中...",
      loadMore: "加载更多",
      empty: "没有找到剧本",
      noUploads: "暂无上传记录",
      noRoles: "暂无自制角色",
      scriptImages: "剧本图片",
      roleImages: "角色图片",
      openImage: "查看大图",
      downloadImage: "下载图片",
      scriptCharacters: "角色内容",
      noImages: "暂无图片",
      noCharacters: "暂无角色内容",
      unknownAuthor: "未知作者",
      noDescription: "暂无简介",
      likes: "{count} 赞",
      uses: "{count} 次使用",
      like: "点赞",
      liked: "已赞",
      favorite: "收藏",
      favorited: "已收藏",
      view: "查看",
      statusPending: "审核中",
      statusApproved: "已通过",
      statusRejected: "已拒绝",
      teamTownsfolk: "镇民",
      teamOutsider: "外来者",
      teamMinion: "爪牙",
      teamDemon: "恶魔",
      teamTraveler: "旅行者",
      teamFabled: "传奇角色",
      teamOther: "其他",
      confirmDelete: "确定删除这个上传的剧本吗？",
      confirmDeleteRole: "确定删除这个自制角色吗？",
      jsonRequired: "请选择 JSON 文件",
      jsonObjectRequired: "JSON 必须是对象或剧本数组",
      titleRequired: "JSON 必须包含 title 或 name 字段",
      invalidJson: "JSON 格式不正确",
      readJsonFailed: "读取 JSON 文件失败",
      loadFailed: "剧本列表加载失败",
      uploadFailed: "上传失败",
      actionFailed: "操作失败",
      loadMineFailed: "我的上传加载失败",
      loadDetailFailed: "上传详情加载失败",
      loadRolesFailed: "我的角色加载失败",
      loadRoleDetailFailed: "角色详情加载失败",
      deleteFailed: "删除失败",
      deleteRoleFailed: "删除角色失败",
    },
    roleLibrary: {
      title: "角色列表",
      hint: "浏览官方角色和我的自制角色",
      create: "创建角色",
      createTitle: "创建自制角色",
      submitCreate: "创建",
      creating: "创建中",
      roleId: "ID（自动生成）",
      roleName: "角色名字",
      roleTeam: "阵营",
      roleAbility: "能力描述",
      roleImage: "角色图片",
      roleToken: "小 token",
      tokenTextPlaceholder: "小 token 文本",
      tokenImagePlaceholder: "小 token 图片地址",
      addToken: "添加 token",
      firstNight: "首夜行动顺序",
      firstNightReminder: "首夜提醒",
      otherNight: "其他夜行动顺序",
      otherNightReminder: "其他夜提醒",
      uploadImage: "上传图片",
      uploadToken: "上传 token",
      generateAiIcon: "AI 生成图标",
      applyAiIcon: "应用图标",
      generateIconFailed: "AI 生成图标失败",
      iconKeywords: "图标关键词",
      iconKeywordsPlaceholder: "例如：眼睛、匕首、月亮、风暴",
      iconKeywordsRequired: "请输入图标关键词",
      searchPlaceholder: "搜索角色名、ID 或技能",
      loading: "加载中...",
      loadMore: "加载更多",
      empty: "没有找到角色",
      loadFailed: "角色列表加载失败",
      createFailed: "创建角色失败",
      nameRequired: "请输入角色名字",
      teamRequired: "请选择阵营",
      uploadImageFailed: "图片上传失败",
      invalidJson: "JSON 格式不正确",
      jsonRequired: "请输入角色 JSON",
      jsonObjectRequired: "角色 JSON 必须是单个对象",
      jsonPlaceholder:
        '粘贴一个角色对象，例如：{"id":"my-role","name":"自制角色","team":"townsfolk","ability":"技能描述","image":"图片地址"}',
      images: "角色图片",
      noAbility: "暂无技能描述",
      allTeams: "全部阵营",
      sources: {
        all: "全部",
        official: "官方",
        custom: "自制",
      },
    },
    roleTokenGenerator: {
      title: "角色 token 生成",
      hint: "上传或粘贴图片，处理成血染钟楼风格图标并保存到自定义角色",
      team: "风格",
      targetRole: "保存到角色",
      targetPlaceholder: "请选择自定义角色",
      uploadTitle: "上传图片",
      uploadHint: "拖拽、点击选择，或直接 Ctrl+V 粘贴图片",
      inputMode: "输入图片类型",
      modeAuto: "自动检测",
      modeBlackWhite: "黑白线稿",
      modeGreyscale: "灰度/彩色",
      processing: "图片处理",
      removeBackground: "移除白色背景",
      invert: "反色",
      crop: "裁剪透明边缘",
      padding: "添加留白",
      dropShadow: "阴影",
      smoothBlend: "平滑混合",
      horizontalPadding: "横向留白",
      threshold: "黑白阈值",
      border: "添加白边",
      borderSize: "白边像素",
      outputSize: "指定输出尺寸",
      sizePixels: "尺寸像素",
      previewEmpty: "处理后的 token 会显示在这里",
      process: "生成 token",
      processingState: "处理中",
      color: "颜色",
      colorGood: "善良",
      colorEvil: "邪恶",
      colorTraveller: "旅行者",
      colorFabled: "传说角色",
      colorLoric: "神奇角色",
      colorTravellerGood: "旅行者（善良）",
      colorTravellerEvil: "旅行者（邪恶）",
      shortcuts: "快捷链接",
      searchVector: "搜索线稿图片",
      removeBgLink: "去除图片背景",
      colorTeam: "按阵营",
      colorOriginal: "原图",
      adjustments: "预览调整",
      scale: "缩放",
      rotation: "旋转",
      download: "下载到本地",
      save: "保存到角色 icon",
      saving: "保存中",
      loadingRoles: "正在加载我的角色...",
      noRoles: "还没有自定义角色，请先在角色列表里创建",
      invalidFile: "请选择图片文件",
      pasted: "粘贴的图片",
      roleRequired: "请选择要保存的角色",
      processFailed: "图片处理失败",
      textureLoadFailed: "纹理加载失败：{texture}（{url}）",
      canvasReadFailed: "无法读取图片像素，请换用本地上传的 PNG/JPG 图片",
      saveFailed: "保存角色 icon 失败",
      saved: "已保存到角色 icon",
      loadRolesFailed: "我的角色加载失败",
      networkError: "请求失败，请检查网络或稍后重试",
    },
    playerName: {
      title: "修改名字",
      label: "名字",
      hint: "保存后会同步到你当前认领的座位。",
    },
    storyLog: {
      title: "主持日志",
      setup: "开局配置",
      night: "夜晚",
      day: "白天",
      firstNight: "首夜",
      nightNumber: "第 {count} 夜",
      dayNumber: "第 {count} 天",
      auto: "自动",
      manual: "手动",
      note: "备注",
      info: "信息",
      status: "状态",
      custom: "自定义",
      newGame: "新开一局",
      clearCurrent: "清空本局",
      exportReview: "导出复盘",
      copyReviewText: "复制复盘文本",
      copyReviewSuccess: "已复制复盘文本",
      copyReviewFailed: "复制失败，请手动选择文本",
      reviewTitle: "血染钟楼复盘记录",
      exportedAt: "导出时间",
      scriptName: "剧本",
      roomId: "房间",
      playerCount: "玩家数",
      playersAndRoles: "玩家与角色",
      seat: "座位",
      player: "玩家",
      role: "角色",
      team: "阵营",
      voteHistory: "投票记录",
      majority: "多数票",
      voters: "投票玩家",
      noVoteHistory: "暂无投票记录",
      currentPhase: "当前记录阶段",
      adjustPhase: "调整阶段",
      movePhase: "移动阶段",
      empty: "暂无主持记录",
      inputPlaceholder: "记录说书人信息、判断或补充说明",
      supplement: "补充",
      supplementPrompt: "补充内容",
      editPrompt: "编辑内容",
      phasePrompt: "阶段编号",
      confirmDelete: "确定删除这条记录吗？",
      confirmClear: "确定清空本局日志吗？这不会改变当前盘面。",
      confirmNewGame: "确定新开一局日志吗？当前日志会保留到历史记录。",
      confirmExportReview:
        "复盘文件会包含当前主持日志、玩家角色和投票记录，确定导出吗？",
    },
    privateChat: {
      title: "聊天",
      sendTo: "发送给",
      chooseTarget: "选择私聊对象",
      publicChannel: "公聊频道",
      host: "说书人",
      noRoom: "请先加入或主持在线房间",
      noTargets: "当前没有可私聊的在线玩家",
      empty: "暂无私聊消息",
      publicEmpty: "暂无公聊消息",
      emptyHint: "第一句话会出现在这里",
      placeholder: "输入私聊内容",
      publicPlaceholder: "输入公聊内容",
      send: "发送",
      me: "我",
      playerName: "玩家 {index}",
    },
    voice: {
      title: "语音",
      entry: "语音私聊",
      connect: "进入语音",
      disconnect: "离开语音",
      micOn: "麦克风开启",
      micOff: "麦克风关闭",
      talkMode: "说话模式",
      freeTalk: "自由发言",
      pushToTalk: "按住说话",
      holdToTalk: "按住说话",
      listenVolume: "收听音量",
      speaking: "正在说话",
      pushToTalkHint: "按住 F2 说话",
      micToggleHint: "按 F2 切换麦克风",
      micShortcutOn: "F2关麦",
      micShortcutOff: "F2开麦",
      storytellerSpeaking: "说书人正在说话",
      currentChannel: "当前频道",
      mainChannel: "主频道",
      privateChannel: "私聊频道",
      emptyChannel: "暂无成员",
      channels: "语音频道",
      inChannel: "当前",
      enter: "进入",
      invite: "邀请私聊",
      invitations: "私聊邀请",
      inviteFrom: "{name} 邀请你私聊",
      rejectedBy: "{name} 拒绝了你的私聊邀请",
      accept: "同意",
      reject: "拒绝",
      dismiss: "知道了",
      noTargets: "当前没有可邀请的在线玩家",
      createPrivate: "发起私聊",
      storytellerControls: "说书人控制",
      muteAll: "全员禁言",
      unmuteAll: "解除禁言",
      recallAll: "召回主频道",
      recallNotice: "说书人正在召回所有玩家，请准备返回主频道。",
      errors: {
        microphone_not_supported: "当前浏览器不支持麦克风。",
        microphone_permission_denied:
          "麦克风权限被拒绝。请在浏览器地址栏或系统设置中允许麦克风后重试。",
        not_channel_member: "你不能进入该私聊频道。",
        recall_in_progress: "召回进行中，暂时不能发起或接受私聊。",
        host_only: "只有说书人可以执行该操作。",
        invalid_invite_targets: "请选择要邀请的玩家。",
      },
    },
    room: {
      title: "房间大厅",
      openLobby: "房间大厅",
      availableRooms: "在线房间",
      all: "全部",
      empty: "暂无在线房间",
      searchPlaceholder: "搜索房间 / 说书人 / 剧本",
      refresh: "刷新",
      create: "创建房间",
      showCreate: "创建房间",
      createRoom: "创建",
      join: "加入",
      joinRoom: "加入 {name}",
      manage: "房间",
      name: "房间名称",
      hostName: "说书人",
      defaultHostName: "说书人",
      note: "备注",
      script: "剧本",
      players: "人数",
      status: "状态",
      waiting: "等待中",
      playing: "游戏中",
      roomControl: "房间控制",
      roomInfo: "房间信息",
      playersGroup: "玩家管理",
      currentPlayers: "当前玩家",
      noCurrentPlayers: "暂无已坐下玩家",
      scriptSettings: "剧本设置",
      roleSettings: "角色管理",
      roomSettings: "房间设置",
      dangerActions: "危险操作",
      syncScript: "同步当前剧本",
      addSeat: "添加座位",
      removeSeat: "移除座位",
      clearPlayers: "清空玩家",
      clearRoles: "清空角色",
      confirmSetPlaying: "角色已发送。是否将房间状态切换为游戏中？",
      visibility: "房间类型",
      public: "公开",
      private: "私密",
      password: "房间密码",
      playerName: "玩家名称",
      scriptJson: "剧本 JSON",
      currentScript: "当前剧本",
      chooseScript: "选择剧本",
      scriptAutoUse: "创建时自动使用当前剧本，可在房间控制中修改。",
      noScript: "未设置剧本",
      save: "保存",
      connectedPlayers: "在线玩家",
      kick: "踢出",
      confirmKick: "确定要把该玩家踢出房间吗？",
      nightNavigation: "夜晚行动",
      firstNight: "首夜",
      otherNights: "其他夜晚",
      previousNightAction: "上一个",
      nextNightAction: "下一个",
      noNightActions: "暂无行动",
      unnamedPlayer: "未命名玩家",
      errors: {
        room_not_found: "房间不存在。",
        room_full: "房间已满。",
        password_required: "请输入房间密码。",
        invalid_password: "房间密码错误。",
        host_disconnected: "主持人暂时断线，房间正在等待重连。",
        banned: "你已被移出该房间，暂时不能重新加入。",
        duplicate_host: "该房间已经有主持人。",
        host_only: "只有房主可以执行该操作。",
        invalid_room_name: "请输入房间名称。",
        invalid_host_name: "请输入说书人名称。",
        invalid_player_name: "请输入玩家名称。",
        invalid_script_json: "剧本 JSON 格式不正确。",
        connection_timeout:
          "房间服务没有响应，请确认当前连接的是已更新的房间服务。",
        kicked: "你已被移出房间。",
        closed: "主持人已离开，房间已关闭。",
      },
    },
    intro: {
      welcomePrefix: "欢迎来到（非官方）",
      title: "血染钟楼虚拟城镇广场与魔典",
      welcomeSuffix: "！",
      addPlayersPrefix: "请通过右上角的",
      menu: "菜单",
      addPlayersSuffix:
        "添加更多玩家，或按 [A] 添加。你也可以按 [J] 加入游戏房间。",
      footerPrefix: "本项目免费且开源，可在",
      github: "GitHub",
      footerSuffix:
        '查看。它与 The Pandemonium Institute 没有关联。"Blood on the Clocktower" 是 Steven Medway 和 The Pandemonium Institute 的商标。',
    },
    townInfo: {
      addMorePlayers: "请添加更多玩家！",
      byAuthor: "作者：{author}",
      nightPhase: "夜晚阶段",
    },
    vote: {
      nominated: "提名了",
      votesInFavor: "{count} 票赞成",
      majority: "多数票为 {count}",
      timePerPlayer: "每名玩家时间：",
      countdown: "倒计时",
      restart: "重新开始",
      start: "开始",
      pause: "暂停",
      resume: "继续",
      reset: "重置",
      markForExecution: "标记处决",
      clearMark: "清除标记",
      secondsBetweenVotes: "每票间隔 {seconds} 秒",
      handDown: "放下手",
      handUp: "举手",
      claimSeatToVote: "请先认领座位再投票。",
    },
    townSquare: {
      otherCharacters: "其他角色",
      demonBluffs: "恶魔伪装",
      lunaticBluffs: "疯子伪装",
      choosePlayer: "选择玩家",
      send: "发送",
      unnamedPlayer: "未命名玩家",
      playerNotConnected: "该座位玩家未入座或不在线",
      fabled: "传奇角色",
      firstNight: "首夜",
      otherNights: "其他夜晚",
      confirmRemovePlayer: "确定要移除 {name} 吗？",
    },
    player: {
      handUp: "举手",
      handDown: "放下手",
      cancel: "取消",
      swapWithPlayer: "与该玩家交换座位",
      moveToSeat: "移动玩家到该座位",
      nominatePlayer: "提名该玩家",
      ghostVote: "亡魂票",
      changePronouns: "修改称谓",
      rename: "重命名",
      flipToken: "图标倒置",
      movePlayer: "移动玩家",
      swapSeats: "交换座位",
      remove: "移除",
      emptySeat: "清空座位",
      nomination: "提名",
      claimSeat: "认领座位",
      vacateSeat: "离开座位",
      seatOccupied: "座位已占用",
      promptPronouns: "玩家称谓",
      promptName: "玩家名称",
    },
    modals: {
      chooseEdition: "选择版本：",
      chooseScript: "选择剧本",
      searchScripts: "搜索展览剧本",
      loadingScripts: "正在加载剧本...",
      loadScriptsFailed: "加载剧本列表失败",
      loadScriptFailed: "加载剧本失败",
      noScriptsFound: "未找到剧本",
      officialScripts: "内置剧本",
      unknownAuthor: "未知作者",
      scriptLikes: "{count} 赞",
      scriptViews: "{count} 次浏览",
      scriptJsonMissing: "该剧本没有可应用的 JSON 内容",
      loadCustomTitle: "加载自定义剧本 / 角色",
      loadCustomDescription:
        "如需游玩自定义剧本，请在官方剧本工具中选择要使用的角色，然后在这里上传生成的 custom-list.json，或提供该 JSON 文件的 URL。",
      scriptTool: "剧本工具",
      customCharactersDescription: "如需游玩自定义角色，请阅读",
      documentation: "文档",
      customCharactersSuffix: "，了解如何编写自定义角色定义文件。",
      trustWarning: "只加载你信任来源的自定义 JSON 文件！",
      popularScripts: "热门自定义剧本：",
      useClipboard: "使用剪贴板中的 JSON",
      promptCustomUrl: "输入 custom-script.json 文件 URL",
      errorReadCustom: "读取自定义剧本失败：{message}",
      errorLoadCustom: "加载自定义剧本失败：{message}",
      selectCharacters: "为 {count} 名玩家选择角色：",
      setupWarning:
        "警告：已选择会改变游戏设置的角色！随机分配器不会处理这些角色的设置效果。",
      allowDuplicate: "允许重复角色",
      assignCharacters: "随机分配 {count} 个角色",
      shuffleCharacters: "随机选择角色",
      chooseFabled: "选择要加入游戏的传奇角色",
      chooseReminder: "选择一个提醒标记：",
      promptCustomReminder: "添加自定义提醒标记",
      chooseRoleFor: "为 {name} 选择新角色",
      bluffing: "伪装位",
      editionRoles: "当前版本角色",
      otherTravelers: "其他旅行者",
      showNightOrder: "显示夜晚顺序",
      showCharacterReference: "显示角色参考",
      characterReference: "角色参考",
      nightOrder: "夜晚顺序",
      firstNight: "首夜",
      otherNights: "其他夜晚",
      jinxed: "相克规则",
      minionInfo: "爪牙信息",
      demonInfo: "恶魔信息与伪装",
      minionReminder:
        "如果有多个爪牙，他们互相睁眼确认。展示“这是恶魔”卡，并指向恶魔。",
      demonReminder:
        "展示“这些是你的爪牙”卡，并指向每个爪牙。展示“这些角色不在场”卡，展示 3 个不在场的好人角色标记。",
      voteHistory: "投票记录",
      clearVoteHistory: "清空投票记录",
      accessibleToPlayers: "玩家可查看",
      clearForEveryone: "为所有人清空",
      time: "时间",
      nominator: "提名者",
      nominee: "被提名者",
      type: "类型",
      votes: "票数",
      majority: "多数票",
      voters: "投票者",
      currentGameState: "当前游戏状态",
      unableToParseJson: "无法解析 JSON：{message}",
      scriptCreator: {
        title: "剧本创作",
        searchPlaceholder: "搜索角色名、ID 或技能",
        selectedTitle: "已选角色",
        emptyTeam: "尚未选择",
        sections: {
          meta: "基础信息",
          counts: "角色数量",
          roles: "角色选择",
        },
        fields: {
          name: "剧本名",
          author: "作者",
        },
        sources: {
          all: "全部",
          official: "官方",
          public_custom: "自制",
          mine: "我的",
        },
        teams: {
          townsfolk: "镇民",
          outsider: "外来者",
          minion: "爪牙",
          demon: "恶魔",
          traveler: "旅行者",
          fabled: "传奇角色",
        },
        validation: {
          teamCount: "{team}：需要 {expected}，当前 {actual}",
        },
        actions: {
          random: "随机",
          includeCustom: "随机包含自制角色",
          remove: "移除",
          downloadJson: "下载 JSON",
        },
        status: {
          loadingRoles: "正在从知识库加载角色...",
          emptyRoles: "知识库暂无可用角色",
          emptyTeamRoles: "该阵营暂无可显示角色",
          loadFailed: "加载知识库角色失败",
          untitled: "未命名剧本",
          copied: "已复制剧本 JSON",
          downloaded: "已下载剧本 JSON",
        },
      },
      imageGenerator: {
        title: "图片生成",
        description: "选择当前剧本，生成接近参考图的剧本海报。",
        currentScript: "当前剧本",
        unnamedScript: "未命名剧本",
        roleCount: "{count} 个角色",
        chooseScript: "选择剧本",
        fields: {
          topTitle: "顶部区域标题",
          topTitlePlaceholder: "默认显示 修行渐远",
          topContent: "顶部区域内容",
          topContentPlaceholder: "按空格分隔，显示在 JSON 自动排版区域",
          scriptName: "剧本名称",
          scriptJsonPlaceholder: "默认从剧本 JSON 读取",
          authorName: "作者名称",
          authorJsonPlaceholder: "默认从剧本 JSON 读取",
          posterBackground: "底板图片",
        },
        settings: {
          summary: "布局参数",
          sections: {
            basic: "顶部与阵营",
            roles: "角色",
            night: "夜晚顺序",
            glossary: "底部说明",
          },
          controls: {
            teamTitleLeft: "阵营标题左距",
            roleAreaLeft: "角色区域左距",
            roleAreaTop: "角色区域上距",
            roleAreaTitleGap: "标题到角色间距",
            headerPanelOffsetX: "顶部区域横移",
            showHeaderPanel: "显示顶部区域框",
            headerPanelWidth: "顶部区域宽度",
            headerPanelHeight: "顶部区域高度",
            headerPanelTitleTop: "顶部区域标题上距",
            headerPanelContentTop: "顶部区域内容上距",
            headerTitleOffsetX: "剧本名横移",
            headerTitleOffsetY: "剧本名纵移",
            titleArtStyle: "剧本名艺术字",
            headerAuthorColor: "作者名字颜色",
            headerAuthorOffsetX: "作者横移",
            headerAuthorOffsetY: "作者纵移",
            roleIconSize: "角色图片大小",
            roleNameColor: "角色名字颜色",
            roleAbilityColor: "角色技能颜色",
            roleNameFontSize: "角色名字字号",
            roleAbilityFontSize: "角色技能字号",
            roleNameAbilityGap: "名字技能间距",
            abilityTextWidth: "技能文字宽度",
            abilityLineHeight: "技能行间距",
            roleGap: "角色间距",
            townsfolkRoleGap: "镇民角色间距",
            outsiderRoleGap: "外来者角色间距",
            minionRoleGap: "爪牙角色间距",
            demonRoleGap: "恶魔角色间距",
            teamGap: "阵营间距",
            townsfolkTeamGap: "镇民阵营间距",
            outsiderTeamGap: "外来者阵营间距",
            minionTeamGap: "爪牙阵营间距",
            demonTeamGap: "恶魔阵营间距",
            nightIconSize: "夜晚图片大小",
            nightIconGap: "夜晚图片间隔",
            nightTitleFontSize: "夜晚标题字号",
            nightFirstTitleFontSize: "首夜字号",
            nightOtherTitleFontSize: "其他夜字号",
            nightTitleLeftOffset: "夜晚标题边距",
            showNightOrder: "显示夜晚行动顺序",
            nightTopOffset: "夜晚顺序距顶部区域",
            glossaryBottomOffset: "距离底部高度",
            glossaryTextGap: "标题文本间距",
          },
        },
        titleArtStyle: {
          classic: "经典",
          goldEmboss: "鎏金浮雕",
          cinnabarSeal: "朱砂印章",
          midnightBlue: "午夜蓝",
          darkGold: "暗金",
        },
        backgrounds: {
          default: "默认羊皮纸",
          wedding: "背景图片 {index}",
        },
        glossary: {
          toggle: "显示可能 / 中毒 / 醉酒",
          title: "可能 / 中毒 / 醉酒",
          description:
            "某件事可能发生时，由说书人决定是否发生。中毒或醉酒的玩家会失去能力，但会以为自己仍有能力。",
        },
        actions: {
          preview: "生成预览",
          downloadPng: "下载 PNG",
          downloadPngGenerating: "服务器生成中...",
        },
        status: {
          previewGenerating: "正在生成预览...",
          previewGenerated: "预览已生成",
          previewGeneratedFallback:
            "预览已生成；部分远程角色图片无法代理，PNG 导出将使用占位图。",
          backgroundFallback: "背景加载失败，已使用模板背景",
          serverGenerating: "正在由服务器生成 PNG...",
          serverGenerated: "服务器已生成 PNG",
        },
        errors: {
          generateFailed: "生成失败",
          redrawFailed: "重绘失败",
          backendFailedFallback: "后端 PNG 生成失败，已使用预览兜底下载",
          previewRequired: "请先生成预览",
          loginRequired: "请先登录后生成 PNG",
          missingPayload: "缺少海报渲染数据",
          canvasNotReady: "海报画布尚未准备好",
        },
        canvas: {
          author: "剧本作者：{author}",
          unknownAuthor: "未知",
          autoLayout: "JSON 自动排版",
          defaultTopTitle: "修行渐远",
          scriptTitle: "剧本标题",
          fallbackWatermark: "染然钟楼",
          watermark: "问题反馈Q群：961227547",
          empty: "选择剧本来生成海报",
          firstNight: "首夜",
          otherNight: "其他夜",
        },
        team: {
          townsfolk: "善良阵营·镇民",
          outsider: "善良阵营·外来者",
          minion: "邪恶阵营·爪牙",
          demon: "邪恶阵营·恶魔",
          traveller: "旅行者",
          fabled: "传奇角色",
        },
      },
      team: {
        townsfolk: "镇民",
        outsider: "外来者",
        minion: "爪牙",
        demon: "恶魔",
        traveler: "旅行者",
        fabled: "传奇角色",
      },
    },
    session: {
      missingCustomRoles:
        "本房间包含当前找不到的自定义角色。请先加载它们再加入！缺失角色：{roles}",
    },
  },
  "en-US": {
    app: {
      titlePublic: "Blood on the Clocktower Town Square",
      titleGrimoire: "Blood on the Clocktower Grimoire",
    },
    common: {
      language: "Language",
      chinese: "中文",
      english: "English",
      customScript: "Custom Script",
      customScriptCharacters: "Custom Script / Characters",
      customNote: "Custom note",
      good: "Good",
      evil: "Evil",
      close: "Close",
      back: "Back",
      copyJson: "Copy JSON",
      loadState: "Load State",
      uploadJson: "Upload JSON",
      enterUrl: "Enter URL",
      add: "Add",
      edit: "Edit",
      remove: "Remove",
      ok: "OK",
      cancel: "Cancel",
    },
    announcements: {
      title: "Announcements",
      version: "Current version: {version}",
      loading: "Loading announcements...",
      empty: "No announcements",
      failed: "Failed to load announcements",
      backToList: "Back to list",
      publishedAt: "Published at {time}",
      applicableVersion: "Version: {version}",
      types: {
        notice: "Notice",
        update: "Update",
        maintenance: "Maintenance",
        important: "Important",
      },
    },
    menu: {
      recentNominations: "{count} recent {label}",
      sessionTitle: "{count} other players in this session{latency}",
      latency: " ({ping}ms latency)",
      nominationSingular: "nomination",
      nominationPlural: "nominations",
      grimoire: "Grimoire",
      settings: "Settings",
      hide: "Hide",
      show: "Show",
      charactersVisible: "Characters: Visible",
      charactersHidden: "Characters: Hidden",
      switchToNight: "Switch to Night",
      switchToDay: "Switch to Day",
      nightOrder: "Night order",
      zoom: "Zoom",
      backgroundImage: "Background image",
      showCustomImages: "Show Custom Images",
      statusEffects: "Drunk/poisoned effects",
      statusEffectsOn: "On",
      statusEffectsOff: "Off",
      disableAnimations: "Disable Animations",
      changePlayerName: "Change name",
      muteSounds: "Mute Sounds",
      storyLog: "Storyteller Log",
      privateChat: "Private Chat",
      webLogin: "Web Login",
      playing: "Playing",
      hosting: "Hosting",
      liveSession: "Live Session",
      host: "Host (Storyteller)",
      join: "Join (Player)",
      delayTo: "Delay to {target}",
      hostTarget: "host",
      playersTarget: "players",
      copyPlayerLink: "Copy player link",
      copyShareLink: "Copy share link",
      sendCharacters: "Send Characters",
      voteHistory: "Vote history",
      leaveSession: "Leave Session",
      players: "Players",
      add: "Add",
      randomize: "Randomize",
      removeAll: "Remove all",
      characters: "Characters",
      selectEdition: "Select Edition",
      selectScript: "Select Script",
      chooseAssign: "Choose & Assign",
      addFabled: "Add Fabled",
      help: "Help",
      referenceSheet: "Reference Sheet",
      nightOrderSheet: "Night Order Sheet",
      clearSeats: "Clear Seats",
      my: "My",
      scriptLibrary: "Script Library",
      roleLibrary: "Role Library",
      tokenGenerator: "Role Token Generator",
      myUploads: "My Uploads",
      downloadRuntimeLog: "Download Logs",
      tools: "Tools",
      imageGenerator: "Image Generator",
      gameStateJson: "Game State JSON",
      scriptCreator: "Script Creator",
      joinDiscord: "Join Discord",
      sourceCode: "Source code",
      promptBackground: "Enter custom background URL",
      promptHost: "Enter a channel number / name for your session",
      promptJoin:
        "Enter the channel number / name of the session you want to join",
      promptPlayerName: "Player name",
      promptJoinPlayerName: "Enter your player name",
      promptPlayerCount:
        "Enter the number of players to add, or enter one player name",
      confirmDistribute:
        "Do you want to distribute assigned characters to all SEATED players?",
      confirmCustomImages:
        "Are you sure you want to allow custom images? A malicious script file author might track your IP address this way.",
      confirmLeave: "Are you sure you want to leave the active live game?",
      confirmRandomize: "Are you sure you want to randomize seatings?",
      confirmClearPlayers: "Are you sure you want to remove all players?",
      confirmClearRoles: "Are you sure you want to remove all player roles?",
    },
    roleDraw: {
      title: "Player Role Draw",
      simulateRoleDraw: "Simulate player role draw",
      yourTurn: "It is your turn to draw a role",
      drawButton: "Draw role",
      remaining: "{count} remaining",
      poolCount: "{count} roles in pool",
      startSeat: "Start seat",
      forward: "Forward",
      reverse: "Reverse",
      start: "Start draw",
      manualDefaultRandom: "Let storyteller draw for current player",
      autoDefaultRandom: "Auto draw after timeout",
      autoDrawSeconds: "Wait seconds",
      helpCurrentPlayerDraw: "Draw for current player",
      currentSeat: "Drawing seat {seat}",
      countdown: "{seconds}s remaining",
    },
    login: {
      title: "Web Login",
      qrAlt: "Web login QR code",
      pending: "Scan this QR code from the mini-program home page",
      approved: "Login successful",
      expired: "QR code expired. Please refresh.",
      failed: "Login failed",
      retrying: "Network is unstable. Retrying...",
      refresh: "Refresh QR Code",
      expiresIn: "Expires in {seconds}s",
      loggedIn: "Logged in",
      expiredSession: "Login expired. Please scan the QR code again.",
      confirmLogout: "Are you sure you want to log out of web login?",
      createFailed: "Failed to create login QR code",
      pollFailed: "Failed to check login status",
      missingUniCloudConfig: "uniCloud web config is not configured",
      missingUniCloudSdk: "uniCloud Web SDK is not loaded",
      networkError:
        "Login request failed. Please refresh the QR code and try again.",
    },
    settings: {
      entry: "Settings",
      title: "Settings",
      profile: {
        title: "Profile",
        avatarUrl: "Avatar URL",
        avatarPlaceholder: "https://example.com/avatar.png",
        nickname: "Name",
        nicknamePlaceholder: "Enter display name",
        saved: "Profile saved",
        saveFailed: "Failed to save profile",
      },
      ai: {
        title: "AI Config",
        enabled: "Enable AI",
        provider: "Provider",
        baseUrl: "Base URL",
        apiKey: "API Key",
        apiKeyPlaceholder: "Leave blank to keep the server key",
        chatModel: "Chat model",
        imageModel: "Image model",
        loadFailed: "Failed to load AI config",
        saveFailed: "Failed to save AI config",
        saved: "AI config saved",
      },
      actions: {
        saveProfile: "Save profile",
        saveAi: "Save AI config",
      },
    },
    myScripts: {
      libraryTitle: "Script Library",
      libraryHint: "Public scripts",
      myUploadsTitle: "My Uploads",
      myUploadsHint: "Manage scripts I submitted",
      upload: "Upload",
      uploadTitle: "Upload Script",
      addCover: "Add Cover",
      addImage: "Add Image",
      scriptType: "Script Type",
      reasoning: "Reasoning",
      fun: "Fun",
      jsonFile: "JSON File",
      chooseJson: "Choose JSON",
      pasteJson: "Paste JSON",
      pasteJsonPlaceholder: "Paste script JSON here",
      submit: "Submit for Review",
      submitting: "Submitting",
      uploaded: "Submitted for review",
      tabs: {
        scripts: "Scripts",
        roles: "Roles",
      },
      searchPlaceholder: "Search scripts / authors",
      searchMinePlaceholder: "Search my uploads",
      searchRolesPlaceholder: "Search my custom roles",
      loading: "Loading...",
      loadMore: "Load More",
      empty: "No scripts found",
      noUploads: "No uploads yet",
      noRoles: "No custom roles yet",
      scriptImages: "Script images",
      roleImages: "Role images",
      openImage: "View image",
      downloadImage: "Download image",
      scriptCharacters: "Characters",
      noImages: "No images",
      noCharacters: "No character content",
      unknownAuthor: "Unknown author",
      noDescription: "No description",
      likes: "{count} likes",
      uses: "{count} uses",
      like: "Like",
      liked: "Liked",
      favorite: "Favorite",
      favorited: "Favorited",
      view: "View",
      statusPending: "Pending",
      statusApproved: "Approved",
      statusRejected: "Rejected",
      teamTownsfolk: "Townsfolk",
      teamOutsider: "Outsiders",
      teamMinion: "Minions",
      teamDemon: "Demons",
      teamTraveler: "Travelers",
      teamFabled: "Fabled",
      teamOther: "Other",
      confirmDelete: "Delete this uploaded script?",
      confirmDeleteRole: "Delete this custom role?",
      jsonRequired: "Choose a JSON file",
      jsonObjectRequired: "JSON must be an object or script array",
      titleRequired: "JSON must include a title or name field",
      invalidJson: "Invalid JSON format",
      readJsonFailed: "Failed to read JSON file",
      loadFailed: "Failed to load scripts",
      uploadFailed: "Upload failed",
      actionFailed: "Action failed",
      loadMineFailed: "Failed to load my uploads",
      loadDetailFailed: "Failed to load upload detail",
      loadRolesFailed: "Failed to load my roles",
      loadRoleDetailFailed: "Failed to load role detail",
      deleteFailed: "Delete failed",
      deleteRoleFailed: "Failed to delete role",
    },
    roleLibrary: {
      title: "Role Library",
      hint: "Browse official roles and my custom roles",
      create: "Create Role",
      createTitle: "Create Custom Role",
      submitCreate: "Create",
      creating: "Creating",
      roleId: "ID (auto generated)",
      roleName: "Role name",
      roleTeam: "Team",
      roleAbility: "Ability",
      roleImage: "Role image",
      roleToken: "Small token",
      tokenTextPlaceholder: "Small token text",
      tokenImagePlaceholder: "Small token image URL",
      addToken: "Add token",
      firstNight: "First night order",
      firstNightReminder: "First night reminder",
      otherNight: "Other night order",
      otherNightReminder: "Other night reminder",
      uploadImage: "Upload image",
      uploadToken: "Upload token",
      generateAiIcon: "AI generate icon",
      applyAiIcon: "Apply icon",
      generateIconFailed: "AI icon generation failed",
      iconKeywords: "Icon keywords",
      iconKeywordsPlaceholder: "e.g. eye, dagger, moon, storm",
      iconKeywordsRequired: "Enter icon keywords",
      searchPlaceholder: "Search role name, ID, or ability",
      loading: "Loading...",
      loadMore: "Load More",
      empty: "No roles found",
      loadFailed: "Failed to load roles",
      createFailed: "Failed to create role",
      nameRequired: "Enter a role name",
      teamRequired: "Choose a team",
      uploadImageFailed: "Failed to upload image",
      invalidJson: "Invalid JSON format",
      jsonRequired: "Enter role JSON",
      jsonObjectRequired: "Role JSON must be one object",
      jsonPlaceholder:
        'Paste one role object, e.g. {"id":"my-role","name":"Custom Role","team":"townsfolk","ability":"Ability text","image":"image url"}',
      images: "Role images",
      noAbility: "No ability text",
      allTeams: "All teams",
      sources: {
        all: "All",
        official: "Official",
        custom: "Custom",
      },
    },
    roleTokenGenerator: {
      title: "Role Token Generator",
      hint: "Upload or paste an image, process it into a Clocktower-style icon, and save it to a custom role",
      team: "Style",
      targetRole: "Save to role",
      targetPlaceholder: "Choose a custom role",
      uploadTitle: "Upload image",
      uploadHint: "Drop, click to browse, or paste with Ctrl+V",
      inputMode: "Input image type",
      modeAuto: "Detect",
      modeBlackWhite: "Black & white",
      modeGreyscale: "Greyscale/colour",
      processing: "Image processing",
      removeBackground: "Remove white background",
      invert: "Invert colors",
      crop: "Crop transparent edges",
      padding: "Add padding",
      dropShadow: "Drop shadow",
      smoothBlend: "Smooth blend",
      horizontalPadding: "Horizontal padding",
      threshold: "Black/white threshold",
      border: "Add white border",
      borderSize: "Border size",
      outputSize: "Set output size",
      sizePixels: "Size in pixels",
      previewEmpty: "Processed token preview",
      process: "Generate token",
      processingState: "Processing",
      color: "Color",
      colorGood: "Good",
      colorEvil: "Evil",
      colorTraveller: "Traveller",
      colorFabled: "Fabled",
      colorLoric: "Loric",
      colorTravellerGood: "Traveller (Good)",
      colorTravellerEvil: "Traveller (Evil)",
      shortcuts: "Quick links",
      searchVector: "Search line art",
      removeBgLink: "Remove background",
      colorTeam: "By team",
      colorOriginal: "Original",
      adjustments: "Preview adjustments",
      scale: "Scale",
      rotation: "Rotation",
      download: "Download",
      save: "Save to role icon",
      saving: "Saving",
      loadingRoles: "Loading my roles...",
      noRoles: "No custom roles yet. Create one in Role Library first.",
      invalidFile: "Choose an image file",
      pasted: "Pasted image",
      roleRequired: "Choose a target role",
      processFailed: "Image processing failed",
      textureLoadFailed: "Texture failed to load: {texture} ({url})",
      canvasReadFailed:
        "Unable to read image pixels. Try uploading a local PNG/JPG image.",
      saveFailed: "Failed to save role icon",
      saved: "Saved to role icon",
      loadRolesFailed: "Failed to load my roles",
      networkError: "Request failed. Check the network or try again later.",
    },
    playerName: {
      title: "Change name",
      label: "Name",
      hint: "Saved names sync to your claimed seat.",
    },
    storyLog: {
      title: "Storyteller Log",
      setup: "Setup",
      night: "Night",
      day: "Day",
      firstNight: "First Night",
      nightNumber: "Night {count}",
      dayNumber: "Day {count}",
      auto: "Auto",
      manual: "Manual",
      note: "Note",
      info: "Info",
      status: "Status",
      custom: "Custom",
      newGame: "New Game",
      clearCurrent: "Clear Current",
      exportReview: "Export Review",
      copyReviewText: "Copy Review Text",
      copyReviewSuccess: "Review text copied",
      copyReviewFailed: "Copy failed. Please select the text manually.",
      reviewTitle: "Clocktower Review Notes",
      exportedAt: "Exported at",
      scriptName: "Script",
      roomId: "Room",
      playerCount: "Player count",
      playersAndRoles: "Players and Roles",
      seat: "Seat",
      player: "Player",
      role: "Role",
      team: "Team",
      voteHistory: "Vote History",
      majority: "majority",
      voters: "voters",
      noVoteHistory: "No vote history yet",
      currentPhase: "Current log phase",
      adjustPhase: "Adjust Phase",
      movePhase: "Move Phase",
      empty: "No storyteller logs yet",
      inputPlaceholder: "Record information, judgement calls, or notes",
      supplement: "Add detail",
      supplementPrompt: "Supplement content",
      editPrompt: "Edit content",
      phasePrompt: "Phase number",
      confirmDelete: "Delete this log entry?",
      confirmClear:
        "Clear logs for this game? This will not change the current board.",
      confirmNewGame:
        "Start a new log game? Current logs will remain in history.",
      confirmExportReview:
        "The review file will include current storyteller logs, player roles, and vote history. Export it?",
    },
    privateChat: {
      title: "Chat",
      sendTo: "Send to",
      chooseTarget: "Choose a recipient",
      publicChannel: "Public Chat",
      host: "Storyteller",
      noRoom: "Join or host an online room first.",
      noTargets: "No online players are available for private chat.",
      empty: "No private messages yet",
      publicEmpty: "No public messages yet",
      emptyHint: "The first message will appear here.",
      placeholder: "Type a private message",
      publicPlaceholder: "Type a public message",
      send: "Send",
      me: "Me",
      playerName: "Player {index}",
    },
    voice: {
      title: "Voice",
      entry: "Voice chat",
      connect: "Join voice",
      disconnect: "Leave voice",
      micOn: "Mic on",
      micOff: "Mic off",
      talkMode: "Talk mode",
      freeTalk: "Free talk",
      pushToTalk: "Push to talk",
      holdToTalk: "Hold to talk",
      listenVolume: "Listen volume",
      speaking: "Speaking",
      pushToTalkHint: "Hold F2 to talk",
      micToggleHint: "Press F2 to toggle mic",
      micShortcutOn: "F2 mute",
      micShortcutOff: "F2 unmute",
      storytellerSpeaking: "Storyteller speaking",
      currentChannel: "Current channel",
      mainChannel: "Main channel",
      privateChannel: "Private channel",
      emptyChannel: "No members",
      channels: "Voice channels",
      inChannel: "Here",
      enter: "Enter",
      invite: "Invite private chat",
      invitations: "Private invites",
      inviteFrom: "{name} invited you",
      rejectedBy: "{name} declined your private chat invite",
      accept: "Accept",
      reject: "Reject",
      dismiss: "OK",
      noTargets: "No online players can be invited.",
      createPrivate: "Start private chat",
      storytellerControls: "Storyteller controls",
      muteAll: "Mute all",
      unmuteAll: "Unmute all",
      recallAll: "Recall to main",
      recallNotice:
        "The storyteller is recalling everyone to the main channel.",
      errors: {
        microphone_not_supported: "This browser does not support microphones.",
        microphone_permission_denied:
          "Microphone permission was denied. Allow microphone access in your browser or system settings, then try again.",
        not_channel_member: "You cannot enter that private channel.",
        recall_in_progress: "Recall is in progress. Private chats are paused.",
        host_only: "Only the storyteller can do that.",
        invalid_invite_targets: "Choose players to invite.",
      },
    },
    room: {
      title: "Room Lobby",
      openLobby: "Room Lobby",
      availableRooms: "Available Rooms",
      all: "All",
      empty: "No rooms online",
      searchPlaceholder: "Search rooms / storyteller / script",
      refresh: "Refresh",
      create: "Create Room",
      showCreate: "Create Room",
      createRoom: "Create",
      join: "Join",
      joinRoom: "Join {name}",
      manage: "Room",
      name: "Room name",
      hostName: "Storyteller",
      defaultHostName: "Storyteller",
      note: "Note",
      script: "Script",
      players: "Players",
      status: "Status",
      waiting: "Waiting",
      playing: "Playing",
      roomControl: "Room Control",
      roomInfo: "Room Info",
      playersGroup: "Player Management",
      currentPlayers: "Current Players",
      noCurrentPlayers: "No seated players yet",
      scriptSettings: "Script Settings",
      roleSettings: "Role Management",
      roomSettings: "Room Settings",
      dangerActions: "Danger Actions",
      syncScript: "Sync current script",
      addSeat: "Add seat",
      removeSeat: "Remove seat",
      clearPlayers: "Clear players",
      clearRoles: "Clear roles",
      confirmSetPlaying: "Characters sent. Switch room status to playing?",
      visibility: "Visibility",
      public: "Public",
      private: "Private",
      password: "Password",
      playerName: "Player name",
      scriptJson: "Script JSON",
      currentScript: "Current script",
      chooseScript: "Choose Script",
      scriptAutoUse:
        "Uses your current script when creating. You can change it in room control.",
      noScript: "No Script",
      save: "Save",
      connectedPlayers: "Connected players",
      kick: "Kick",
      confirmKick: "Kick this player from the room?",
      nightNavigation: "Night actions",
      firstNight: "First Night",
      otherNights: "Other Nights",
      previousNightAction: "Previous",
      nextNightAction: "Next",
      noNightActions: "No actions",
      unnamedPlayer: "Unnamed player",
      errors: {
        room_not_found: "Room not found.",
        room_full: "This room is full.",
        password_required: "Password required.",
        invalid_password: "Wrong password.",
        host_disconnected:
          "The host is temporarily disconnected. Wait for them to reconnect.",
        banned: "You were removed from this room and cannot rejoin yet.",
        duplicate_host: "This room already has a host.",
        host_only: "Only the host can do that.",
        invalid_room_name: "Enter a room name.",
        invalid_host_name: "Enter a storyteller name.",
        invalid_player_name: "Enter a player name.",
        invalid_script_json: "The script JSON is invalid.",
        connection_timeout:
          "The room service did not respond. Check that this app is connected to the updated room server.",
        kicked: "You were removed from the room.",
        closed: "The host left and the room was closed.",
      },
    },
    intro: {
      welcomePrefix: "Welcome to the (unofficial)",
      title: "Virtual Town Square and Grimoire",
      welcomeSuffix: " for Blood on the Clocktower!",
      addPlayersPrefix: "Please add more players through the",
      menu: "Menu",
      addPlayersSuffix:
        "on the top right or by pressing [A]. You can also join a game session by pressing [J].",
      footerPrefix: "This project is free and open source and can be found on",
      github: "GitHub",
      footerSuffix:
        '. It is not affiliated with The Pandemonium Institute. "Blood on the Clocktower" is a trademark of Steven Medway and The Pandemonium Institute.',
    },
    townInfo: {
      addMorePlayers: "Please add more players!",
      byAuthor: "by {author}",
      nightPhase: "Night phase",
    },
    vote: {
      nominated: "nominated",
      votesInFavor: "{count} vote{plural} in favor",
      majority: "majority is {count}",
      timePerPlayer: "Time per player:",
      countdown: "Countdown",
      restart: "Restart",
      start: "Start",
      pause: "Pause",
      resume: "Resume",
      reset: "Reset",
      markForExecution: "Mark for execution",
      clearMark: "Clear mark",
      secondsBetweenVotes: "{seconds} seconds between votes",
      handDown: "Hand DOWN",
      handUp: "Hand UP",
      claimSeatToVote: "Please claim a seat to vote.",
    },
    townSquare: {
      otherCharacters: "Other characters",
      demonBluffs: "Demon bluffs",
      lunaticBluffs: "Lunatic bluffs",
      choosePlayer: "Choose player",
      send: "Send",
      unnamedPlayer: "Unnamed player",
      playerNotConnected: "That seat is empty or the player is offline",
      fabled: "Fabled",
      firstNight: "First Night",
      otherNights: "Other Nights",
      confirmRemovePlayer: "Do you really want to remove {name}?",
    },
    player: {
      handUp: "Hand UP",
      handDown: "Hand DOWN",
      cancel: "Cancel",
      swapWithPlayer: "Swap seats with this player",
      moveToSeat: "Move player to this seat",
      nominatePlayer: "Nominate this player",
      ghostVote: "Ghost vote",
      changePronouns: "Change Pronouns",
      rename: "Rename",
      flipToken: "Flip icon",
      movePlayer: "Move player",
      swapSeats: "Swap seats",
      remove: "Remove",
      emptySeat: "Empty seat",
      nomination: "Nomination",
      claimSeat: "Claim seat",
      vacateSeat: "Vacate seat",
      seatOccupied: "Seat occupied",
      promptPronouns: "Player pronouns",
      promptName: "Player name",
    },
    modals: {
      chooseEdition: "Select an edition:",
      chooseScript: "Select Script",
      searchScripts: "Search gallery scripts",
      loadingScripts: "Loading scripts...",
      loadScriptsFailed: "Failed to load scripts",
      loadScriptFailed: "Failed to load script",
      noScriptsFound: "No scripts found",
      officialScripts: "Built-in Scripts",
      unknownAuthor: "Unknown author",
      scriptLikes: "{count} likes",
      scriptViews: "{count} views",
      scriptJsonMissing: "This script does not contain applicable JSON content",
      loadCustomTitle: "Load custom script / characters",
      loadCustomDescription:
        "To play with a custom script, you need to select the characters you want to play with in the official",
      scriptTool: "Script Tool",
      customCharactersDescription:
        "To play with custom characters, please read",
      documentation: "the documentation",
      customCharactersSuffix:
        "on how to write a custom character definition file.",
      trustWarning: "Only load custom JSON files from sources that you trust!",
      popularScripts: "Some popular custom scripts:",
      useClipboard: "Use JSON from Clipboard",
      promptCustomUrl: "Enter URL to a custom-script.json file",
      errorReadCustom: "Error reading custom script: {message}",
      errorLoadCustom: "Error loading custom script: {message}",
      selectCharacters: "Select the characters for {count} players:",
      setupWarning:
        "Warning: there are characters selected that modify the game setup! The randomizer does not account for these characters.",
      allowDuplicate: "Allow duplicate characters",
      assignCharacters: "Assign {count} characters randomly",
      shuffleCharacters: "Shuffle characters",
      chooseFabled: "Choose a fabled character to add to the game",
      chooseReminder: "Choose a reminder token:",
      promptCustomReminder: "Add a custom reminder note",
      chooseRoleFor: "Choose a new character for {name}",
      bluffing: "bluffing",
      editionRoles: "Edition Roles",
      otherTravelers: "Other Travelers",
      showNightOrder: "Show Night Order",
      showCharacterReference: "Show Character Reference",
      characterReference: "Character Reference",
      nightOrder: "Night Order",
      firstNight: "First Night",
      otherNights: "Other Nights",
      jinxed: "Jinxed",
      minionInfo: "Minion info",
      demonInfo: "Demon info & bluffs",
      minionReminder:
        'If more than one Minion, they all make eye contact with each other. Show the "This is the Demon" card. Point to the Demon.',
      demonReminder:
        'Show the "These are your minions" card. Point to each Minion. Show the "These characters are not in play" card. Show 3 character tokens of good characters not in play.',
      voteHistory: "Vote history",
      clearVoteHistory: "Clear vote history",
      accessibleToPlayers: "Accessible to players",
      clearForEveryone: "Clear for everyone",
      time: "Time",
      nominator: "Nominator",
      nominee: "Nominee",
      type: "Type",
      votes: "Votes",
      majority: "Majority",
      voters: "Voters",
      currentGameState: "Current Game State",
      unableToParseJson: "Unable to parse JSON: {message}",
      scriptCreator: {
        title: "Script Creator",
        searchPlaceholder: "Search role name, ID, or ability",
        selectedTitle: "Selected Roles",
        emptyTeam: "None selected",
        sections: {
          meta: "Basic Info",
          counts: "Role Counts",
          roles: "Role Selection",
        },
        fields: {
          name: "Script name",
          author: "Author",
        },
        sources: {
          all: "All",
          official: "Official",
          public_custom: "Custom",
          mine: "My",
        },
        teams: {
          townsfolk: "Townsfolk",
          outsider: "Outsiders",
          minion: "Minions",
          demon: "Demon",
          traveler: "Travelers",
          fabled: "Fabled",
        },
        validation: {
          teamCount: "{team}: needs {expected}, selected {actual}",
        },
        actions: {
          random: "Random",
          includeCustom: "Include custom roles",
          remove: "Remove",
          downloadJson: "Download JSON",
        },
        status: {
          loadingRoles: "Loading roles from knowledge base...",
          emptyRoles: "No knowledge base roles available",
          emptyTeamRoles: "No roles to show in this team",
          loadFailed: "Failed to load knowledge base roles",
          untitled: "Untitled Script",
          copied: "Script JSON copied",
          downloaded: "Script JSON downloaded",
        },
      },
      imageGenerator: {
        title: "Image Generator",
        description:
          "Use the current script to generate a poster close to the reference image.",
        currentScript: "Current Script",
        unnamedScript: "Untitled Script",
        roleCount: "{count} roles",
        chooseScript: "Choose Script",
        fields: {
          topTitle: "Top Area Title",
          topTitlePlaceholder: "Defaults to 修行渐远",
          topContent: "Top Area Content",
          topContentPlaceholder:
            "Separate words with spaces for the auto layout area",
          scriptName: "Script Name",
          scriptJsonPlaceholder: "Defaults to the script JSON",
          authorName: "Author Name",
          authorJsonPlaceholder: "Defaults to the script JSON",
          posterBackground: "Base Image",
        },
        settings: {
          summary: "Layout Settings",
          sections: {
            basic: "Header & Teams",
            roles: "Roles",
            night: "Night Order",
            glossary: "Bottom Notes",
          },
          controls: {
            teamTitleLeft: "Team Title Left",
            roleAreaLeft: "Role Area Left",
            roleAreaTop: "Role Area Top",
            roleAreaTitleGap: "Title to Roles Gap",
            headerPanelOffsetX: "Top Area X Offset",
            showHeaderPanel: "Show Top Area Box",
            headerPanelWidth: "Top Area Width",
            headerPanelHeight: "Top Area Height",
            headerPanelTitleTop: "Top Area Title Top",
            headerPanelContentTop: "Top Area Content Top",
            headerTitleOffsetX: "Script Name X Offset",
            headerTitleOffsetY: "Script Name Y Offset",
            titleArtStyle: "Script Name Style",
            headerAuthorColor: "Author Name Color",
            headerAuthorOffsetX: "Author X Offset",
            headerAuthorOffsetY: "Author Y Offset",
            roleIconSize: "Role Image Size",
            roleNameColor: "Role Name Color",
            roleAbilityColor: "Role Ability Color",
            roleNameFontSize: "Role Name Size",
            roleAbilityFontSize: "Role Ability Size",
            roleNameAbilityGap: "Name Ability Gap",
            abilityTextWidth: "Ability Text Width",
            abilityLineHeight: "Ability Line Height",
            roleGap: "Role Gap",
            townsfolkRoleGap: "Townsfolk Role Gap",
            outsiderRoleGap: "Outsider Role Gap",
            minionRoleGap: "Minion Role Gap",
            demonRoleGap: "Demon Role Gap",
            teamGap: "Team Gap",
            townsfolkTeamGap: "Townsfolk Team Gap",
            outsiderTeamGap: "Outsider Team Gap",
            minionTeamGap: "Minion Team Gap",
            demonTeamGap: "Demon Team Gap",
            nightIconSize: "Night Image Size",
            nightIconGap: "Night Image Gap",
            nightTitleFontSize: "Night Title Size",
            nightFirstTitleFontSize: "First Night Size",
            nightOtherTitleFontSize: "Other Night Size",
            nightTitleLeftOffset: "Night Title Margin",
            showNightOrder: "Show Night Action Order",
            nightTopOffset: "Night Order Top Offset",
            glossaryBottomOffset: "Bottom Offset",
            glossaryTextGap: "Title Text Gap",
          },
        },
        titleArtStyle: {
          classic: "Classic",
          goldEmboss: "Gold Emboss",
          cinnabarSeal: "Cinnabar Seal",
          midnightBlue: "Midnight Blue",
          darkGold: "Dark Gold",
        },
        backgrounds: {
          default: "Default Parchment",
          wedding: "Background Image {index}",
        },
        glossary: {
          toggle: "Show might / poisoned / drunk",
          title: "Might / Poisoned / Drunk",
          description:
            "When something might happen, the Storyteller decides whether it happens. Poisoned or drunk players lose their ability, but think they still have it.",
        },
        actions: {
          preview: "Generate Preview",
          downloadPng: "Download PNG",
          downloadPngGenerating: "Generating on server...",
        },
        status: {
          previewGenerating: "Generating preview...",
          previewGenerated: "Preview generated",
          previewGeneratedFallback:
            "Preview generated; some remote role images could not be proxied, so placeholders are used for PNG export.",
          backgroundFallback:
            "Background failed to load; using template background",
          serverGenerating: "Generating PNG on server...",
          serverGenerated: "PNG generated by server",
        },
        errors: {
          generateFailed: "Generate failed",
          redrawFailed: "Redraw failed",
          backendFailedFallback:
            "Backend PNG render failed; using preview fallback",
          previewRequired: "Please generate a preview first",
          loginRequired: "Please log in before generating PNG",
          missingPayload: "Missing poster render payload",
          canvasNotReady: "Poster canvas is not ready",
        },
        canvas: {
          author: "Script author: {author}",
          unknownAuthor: "Unknown",
          autoLayout: "JSON auto layout",
          defaultTopTitle: "修行渐远",
          scriptTitle: "Script Title",
          fallbackWatermark: "Townsquare",
          watermark: "问题反馈Q群：961227547",
          empty: "Choose a script to generate a poster",
          firstNight: "First Night",
          otherNight: "Other Night",
        },
        team: {
          townsfolk: "Good Team - Townsfolk",
          outsider: "Good Team - Outsider",
          minion: "Evil Team - Minion",
          demon: "Evil Team - Demon",
          traveller: "Traveller",
          fabled: "Fabled",
        },
      },
      team: {
        townsfolk: "townsfolk",
        outsider: "outsider",
        minion: "minion",
        demon: "demon",
        traveler: "traveler",
        fabled: "fabled",
      },
    },
    session: {
      missingCustomRoles:
        "This session contains custom characters that can't be found. Please load them before joining! Missing roles: {roles}",
    },
  },
};

const getInitialLocale = () => {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  return locales.some(({ code }) => code === stored) ? stored : DEFAULT_LOCALE;
};

export const i18nState = Vue.observable({
  locale: getInitialLocale(),
});

const resolveMessage = (locale, key) =>
  key.split(".").reduce((value, part) => {
    if (value && Object.prototype.hasOwnProperty.call(value, part)) {
      return value[part];
    }
    return undefined;
  }, messages[locale]);

export const t = (key, params = {}) => {
  const template =
    resolveMessage(i18nState.locale, key) ||
    resolveMessage(DEFAULT_LOCALE, key) ||
    key;

  if (typeof template !== "string") return key;

  return template.replace(/\{(\w+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(params, name) ? params[name] : match,
  );
};

export const setLocale = (locale) => {
  if (!locales.some(({ code }) => code === locale)) return;
  i18nState.locale = locale;
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
};

export const installI18n = () => {
  Vue.prototype.$i18n = i18nState;
  Vue.prototype.$locales = locales;
  Vue.prototype.$t = t;
  Vue.prototype.$setLocale = setLocale;
};
